module.exports = "/images/QcompetitorLogoEvolution.png?4b531567e46c8dc0b1d9f812d52784a0";